import { Homepage } from "../../@types/lang";
import { AnimatePresence, motion } from "framer-motion";
import Image from "../../assets/images/aboutUs/about_us_new.webp";
import Title from "../shared/Title";
import { sectionVariant, showContent } from "../../utils/variants";
import Description from "../shared/Description";

type Props = {
  lang: Homepage;
};

const AboutUs = (props: Props) => {
  return (
    <div className="flex flex-col gap-24">
      {/* About Us */}
      <div className="flex gap-20 flex-col lg:flex-row items-center">
        <div className="w-full max-w-[400px] aspect-square lg:min-w-[400px] rounded-[10px] overflow-hidden">
          <AnimatePresence>
            {!Image ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.1 }}
                exit={{ opacity: 0 }}
                className="h-full w-full animate-pulse bg-gray-400 rounded-[10px]"
              ></motion.div>
            ) : (
              <motion.img
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.25 }}
                exit={{ opacity: 0 }}
                src={Image}
                alt="about-us"
                className="h-full w-full rounded-[10px] object-cover object-center"
                loading="lazy"
              />
            )}
          </AnimatePresence>
        </div>
        <div className="flex flex-col gap-8">
          <Title text={props.lang.aboutus_title} type="p" />
          <Description type="html" text={props.lang.aboutus_description} />
        </div>
      </div>
      {/* Who We Are */}
      <div className="flex gap-4 md:gap-6 flex-col">
        <Title text={props.lang.who_we_are_title} type="p" align="center" />

        <motion.div
          variants={sectionVariant}
          initial="hidden"
          whileInView="visible"
          className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4 mt-4 md:mt-6"
        >
          {props.lang.who_we_are_details.map((item, index) => (
            <motion.div
              variants={showContent}
              key={index}
              custom={item.id}
              className="flex flex-col gap-4 md:gap-6 p-4"
            >
              <div className="flex justify-center">
                <div dangerouslySetInnerHTML={{ __html: item.icon_url }} />
              </div>
              <h3 className="text-xl font-bold text-center uppercase">
                {item.title}
              </h3>
              <p className="text-justify tracking-tighter text-[#3b3b3b]/70 font-normal leading-relaxed">
                {item.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default AboutUs;
